<script>
    import { fly } from "svelte/transition";

    export let open = false;
    export let text = "Vain lukuoikeus";
</script>

<style>
    .toast {
        position: fixed;
        transform: translateX(-50%);
        left: 50%;
        bottom: 1.5rem;
        height: 3rem;
        width: 90%;
        max-width: 360px;
        background: rgba(0, 0, 0, .6);
        color: #fff;
        text-align: center;
        border-radius: 6px;
    }
    p {
        line-height: 3rem;
    }
</style>

{#if open}
    <div class="toast" in:fly={{ duration: 200, y: 50 }} out:fly={{ duration: 200, y: 50 }}>
        <p>{text}</p>
    </div>
{/if}